export { default as de } from './de.json'
export { default as en } from './en.json'
export { default as es } from './es.json'
export { default as it } from './it.json'
export { default as pl } from './pl.json'
export { default as nl } from './nl.json'



// WEBPACK FOOTER //
// ./src/i18n/login/index.js